import axios from './config';

const API_BASE_URL = '/packages_contracts';

const getProcuringEntityPackageContracts = async (params = {}) => {
    try {
        const response = await axios.get(API_BASE_URL, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching procuring entity package contracts:', error);
        throw error;
    }
};

const getProcuringEntityPackageContract = async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching procuring entity package contract:', error);
        throw error;
    }
};

const createProcuringEntityPackageContract = async (data) => {
    try {
        const response = await axios.post(API_BASE_URL, data);
        return response.data;
    } catch (error) {
        console.error('Error creating procuring entity package contract:', error);
        throw error;
    }
};

const updateProcuringEntityPackageContract = async (id, data) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating procuring entity package contract:', error);
        throw error;
    }
};

const deleteProcuringEntityPackageContract = async (id) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting procuring entity package contract:', error);
        throw error;
    }
};

export default {
    getProcuringEntityPackageContracts,
    getProcuringEntityPackageContract,
    createProcuringEntityPackageContract,
    updateProcuringEntityPackageContract,
    deleteProcuringEntityPackageContract
};
